<template> 
    <div class="lsOverlay">
        <i class="fa-duotone fa-spinner-third fa-spin fa-lg" style="--fa-primary-color: #00a6c3; --fa-secondary-color: #6c757d "></i>
    </div>
</template>

<script>
    export default {
        name: 'LoadingSpinner',
        components: {
        },
        data() {
            return {
            };
        },

        computed: {
        },
        methods: {
        }
    }


</script>
<style scoped>
    i.fa-duotone.fa-spinner-third.fa-spin.fa-lg {
        font-size: 60px;
    }

   /* .lsSpinnerBox {
        width: 60px;
        height: 60px;
        border: 4px #ddd solid;
        border-top: 4px var(--main-color-2) solid;
        border-radius: 50%;
        animation: sp-anime 0.8s infinite linear;
    }*/


    .lsOverlay {
        position: fixed;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        z-index: 9999999999;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        background: #8b8a8aba;
        justify-content: center;
    }
</style>
